import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ProductionApiAlert } from 'components/Development';
import { persistor, store } from 'store';
import GlobalStyles from 'styles/global';
import AppRoutes from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'components/ui/sonner';
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';

const App: React.FC = () => {
  console.log('App component rendered - v0.0.2');
  return (
    <Provider store={store}>
      <ProductionApiAlert />
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <GlobalStyles />
          <QueryClientProvider client={new QueryClient()}>
            <MantineProvider>
              <AppRoutes />
              <Toaster expand />
            </MantineProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
